<template>
  <div class="container mt-4">
    <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2 p-1 ">
      <h2 class="mb-0 main-title">Work Order Requests</h2>
      <div class="d-flex align-items-center gap-2">
        <button class="btn btn-md btn-primary fs-11 fw-normal text-white hover-white" @click="openCreateModal('createModal')">
         <i class="fa fa-plus fs-11 hover-white"></i>  Add New Request
        </button>
        
      </div>
    </div>
    
    <!-- Filters Bar -->
    <div class="filters-wrapper">
      <div class="filters-bar" id="filtersBar"></div>
      <button @click="resetAllFilters" class="btn btn-sm btn-outline-danger hover-white">
        <span class="material-symbols-outlined fs-6">undo</span> Reset
      </button>
    </div>

    <!-- Dropdown Template -->
    <div id="genericFilterDropdownTemplate" style="display: none;">
      <div class="generic-filter-dropdown">
        <div class="dropdown-header">
          <input type="text" class="filter-search-input" placeholder="Search...">
        </div>
        <div class="dropdown-body filter-options-container"></div>
        <div class="dropdown-footer">
          <button class="filter-clear-btn">Clear</button>
          <button class="filter-apply-btn">Apply</button>
        </div>
      </div>
    </div>
    
    <div class="card p-1 bg-white">
      <!-- Create Modal -->
      <FormModal ref="createModal" title="Create New Request" id="create_request_form_modal">
        <CreateRequest ref="CreaterequestForm" @created="onCreated" @close="closeCreateModal('createModal')" />
      </FormModal>

      <!-- Edit Modal -->
      <FormModal ref="editModal" title="Edit Request" id="edit_request_form_modal">
        <EditRequest ref="EditRequestForm" @updated="onUpdated" @close="closeEditModal" />
      </FormModal>

      <!-- Loading State -->
      <LoadingBar v-if="loading" message="Loading Requests..." />

      <!-- requests Table -->
      <div v-else class="table-wrapper ">
        <ListTable>
          <thead>
            <tr>
              <th >
                 Request 
              </th>
             
              <th @click="sortBy('issue_related_to')" class="sortable">
                Issue Related To <i :class="getSortIcon('issue_related_to')"></i>
              </th>

               <th @click="sortBy('priority')" class="sortable">
                Priority <i :class="getSortIcon('priority')"></i>
              </th>
              <th @click="sortBy('created_at')" class="sortable">
                Requested At <i :class="getSortIcon('created_at')"></i>
              </th>
                <th @click="sortBy('description')" class="sortable">
                    Description <i :class="getSortIcon('description')"></i> 
                    </th>
              
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="request in sortedData" :key="request.id">
              <td>
              <button  @click.prevent="goToProfile(request.external_id)" class="text-dark fw-semibold  btn btn-sm p-0" title="Click to view details">
            {{ request.title }}
              </button>
              <div class="mt-0">
                <small class="text-muted">#{{ request.external_id }}</small>
              </div>
              </td>
              <td>
                {{ request.issue_related_to !='other' ? request.issue_related_to : request.other_issue_detail }}
            </td>
              <td><span class="priority-badge" :class="'priority-' + request.priority">{{ request.priority }}</span></td>
                <td>{{ request.created_at }}</td>
              <td>{{ $limit(request.description, 50) }}</td>        
              <td>
                <TableActionDropdown>
                  <li><button class="dropdown-item" @click.prevent="viewRequest(request)"><i class="fa fa-eye text-info "></i>View Details</button></li>
                  <li><button class="dropdown-item" @click.prevent="editRequest(request)"><i class="fa fa-pencil text-primary "></i>Edit</button></li>
                  <li><button class="dropdown-item text-danger" @click.prevent="deleteRequest(request.id)"><i class="fa fa-trash text-danger"></i>Delete</button></li>
                </TableActionDropdown>
              </td>
            </tr>
            <tr v-if="requests.length === 0">
              <td colspan="6" class="text-center">No requests found</td>
            </tr>

          </tbody>
        </ListTable>
        
      </div>

      <!-- Pagination -->
      <Pagination :pagination="pagination" @page-change="changePage" />

    </div>
  </div>
</template>

<script>
import { form_api_submit } from '@/utils/FormSubmit'
import Pagination from '@/components/utils/PaginationBar.vue'
import LoadingBar from '@/components/utils/LoadingBar.vue'
import FormModal from '@/components/utils/FormModal.vue'
import CreateRequest from '@/views/WO/Request/CreateRequest.vue'
import EditRequest from '@/views/WO/Request/EditRequest.vue'
import ListTable from '@/components/utils/ListTable.vue'
import TableActionDropdown from '@/components/TableActionDropdown.vue'

export default {
  name: 'requestList',
  components: {
    Pagination,
    LoadingBar,
    FormModal,
    CreateRequest,
    EditRequest,
    ListTable,
    TableActionDropdown
  },
  data() {
    return {
      requests: [],
      pagination: {
        total_rows: 0,
        per_page: 20,
        current_page: 1,
        total_pages: 1
      },
      loading: false,
      filterManager: null,
      sortColumn: 'title',
      sortOrder: 'asc',
      currentFilters: {},
      editingRequest: null,
    }
  },
  computed: {
    sortedData() {
      let result = [...this.requests];

      if (this.sortColumn) {
        result.sort((a, b) => {
          let valA = a[this.sortColumn];
          let valB = b[this.sortColumn];

          if (valA === undefined || valA === null) valA = '';
          if (valB === undefined || valB === null) valB = '';

          if (typeof valA === 'string') valA = valA.toLowerCase();
          if (typeof valB === 'string') valB = valB.toLowerCase();

          if (valA < valB) return this.sortOrder === 'asc' ? -1 : 1;
          if (valA > valB) return this.sortOrder === 'asc' ? 1 : -1;
          return 0;
        });
      }

      return result;
    },
  },
  mounted() {
    this.fetchList()
    this.$nextTick(() => {
      setTimeout(() => {
        this.initFilters();
      }, 100);
    });
  },
  methods: {
    goToProfile(id) {
      this.$router.push(`/wo/request/profile/${id}`)
    },
    
    openCreateModal(ref) {
      this.$refs[ref].showModal()
      if (this.$refs.CreaterequestForm) {
        this.$refs.CreaterequestForm.resetForm()
      }
    },

    closeCreateModal(ref) {
      this.$refs[ref].closeModal()
    },

    closeEditModal() {
      this.$refs.editModal.closeModal()
      this.editingRequest = null
    },

    async onCreated() {
      this.pagination.current_page = 1
      await this.fetchList()
    },

    async onUpdated() {
      this.pagination.current_page = 1
      await this.fetchList()
      this.closeEditModal()
    },

    editRequest(request) {
      this.editingRequest = request
      // Use $nextTick to ensure the component is ready
      this.$nextTick(() => {
        if (this.$refs.editModal) {
          this.$refs.editModal.showModal()
        }
        // Set the data after modal is shown
        setTimeout(() => {
          if (this.$refs.EditRequestForm && this.editingRequest) {
            this.$refs.EditRequestForm.setRequestData(this.editingRequest)
          }
        }, 200)
      })
    },

    async deleteRequest(id) {
      if (!confirm('Are you sure you want to delete this request?')) return

      try {
        this.loading = true
        const result = await form_api_submit({
          url: 'wo/request/delete/' + id,
          method: 'DELETE',
          show_success_toast: true,
          show_error_toast: true
        })

        if (result.success) {
          this.$toast('Request deleted successfully!', true)
          this.pagination.current_page = 1
          await this.fetchList()
        }
      } catch (error) {
        console.error('Error deleting request:', error)
        this.$toast('Failed to delete request', false)
      } finally {
        this.loading = false
      }
    },

    viewRequest(request) {
      this.$router.push(`/wo/request/profile/${request.external_id}`)
    },

    initFilters() {
      if (typeof $ === "undefined" || typeof GenericFilterManager === "undefined") return;

      this.filterManager = new GenericFilterManager({
        containerId: "filtersBar",
        filters: [
          {
            key: "title",
            label: "Title",
            type: "input",
            placeholder: "Filter by Title"
          },
          {
            key: "issue_related_to",
            label: "Issue Related To",
            type: "input",
            placeholder: "Filter by Issue"
          },
          {
            key: "priority",
            label: "Priority",
            type: "checkbox",
            options: [
              { value: "low", label: "Low" },
              { value: "medium", label: "Medium" },
              { value: "high", label: "High" }
            ]
          }
        ],
        onFilterChange: (filters) => {
          this.applyFilters(filters);
        }
      });
    },

    applyFilters(activeFilters) {
      this.currentFilters = { ...activeFilters };
      this.pagination.current_page = 1;
      this.fetchList();
    },

    resetPagination() {
      this.pagination.current_page = 1;
      this.fetchList();
    },

    resetAllFilters() {
      if (this.filterManager) {
        this.filterManager.clearAllFilters();
      }
      this.currentFilters = {};
      this.sortColumn = 'title';
      this.sortOrder = 'asc';
      this.pagination.current_page = 1;
      this.fetchList();
    },

    async fetchList() {
      this.loading = true

      const payload = {
        page: this.pagination.current_page,
        ...this.currentFilters
      }

      const result = await form_api_submit({
        url: 'wo/request/list',
        method: 'GET',
        data: payload,
        show_success_toast: false,
        show_error_toast: true,
        remove_pre_toasts: false
      })

      if (result.success) {
        console.log(result);
        this.requests = result.data.list
        this.pagination = result.data.pagination
      }

      this.loading = false
    },

    changePage(page) {
      if (page < 1 || page > this.pagination.total_pages) return
      this.pagination.current_page = page
      this.fetchList()
    },

    sortBy(column) {
      if (this.sortColumn === column) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortOrder = 'asc';
      }
    },

    getSortIcon(column) {
      if (this.sortColumn !== column) {
        return 'fas fa-sort text-muted';
      }
      return this.sortOrder === 'asc' ? 'fas fa-sort-up text-primary' : 'fas fa-sort-down text-primary';
    },
  }
}
</script>

<style scoped>
.page-link {
  cursor: pointer;
}

.page-item.active .page-link {
  background-color: #667eea;
  border-color: #667eea;
}

img {
  object-fit: cover;
}

/* Filters Wrapper */
/* .filters-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 12px;
  padding: 8px 0;
} */

/* .filters-wrapper .filters-bar {
  flex: 1;
}

.filters-wrapper .btn {
  white-space: nowrap;
  font-size: 12px;
  padding: 4px 12px;
} */

/* Priority Badges */
.priority-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  text-transform: capitalize;
}

.priority-low {
  background: #dbeafe;
  color: #1e40af;
}

.priority-medium {
  background: #fef3c7;
  color: #92400e;
}

.priority-high {
  background: #fee2e2;
  color: #991b1b;
}

.sortable {
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s;
}

.sortable:hover {
  background-color: #f8f9fa;
}

/* Table styling */
.table-wrapper {
  overflow-x: auto;
}

:deep(table) {
  width: 100%;
  border-collapse: collapse;
}

:deep(th) {
  background-color: #f8f9fa;
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  font-size: 12px;
  border-bottom: 1px solid #dee2e6;
}

:deep(td) {
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  vertical-align: middle;
}

:deep(tr:hover) {
  background-color: #f8f9fa;
}

/* Responsive */
@media (max-width: 768px) {
  :deep(th),
  :deep(td) {
    padding: 8px 12px;
  }
  
  .filters-wrapper {
    flex-direction: column;
    align-items: stretch;
  }
  
  .filters-wrapper .btn {
    align-self: flex-end;
  }
}
</style>